<template>
  <el-container>
    <el-header>
      <div class="header clearfix">
        <div class="title">
          <h1 class="title__heading">
            <slot name="title"></slot>
          </h1>
        </div>

        <div class="functional__wrapper">
          <Support/>

          <User/>
        </div>
      </div>
    </el-header>

    <!-- Main -->
    <el-main>
      <div class="main">
        <slot name="main"></slot>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import Support from '@/components/header/Support'
import User from '@/components/header/User'

export default {
  name: 'main-layout',
  components: {
    Support,
    User
  }
}
</script>
